import { ChartLoading, UserPasteRatioChart } from "@vericus/cadmus-common";

import { UserFragment } from "@/generated/graphql";

import { useWordCountActivity } from "../api/use-word-count-activity";
import { DateRange } from "../types";

interface Props {
  assessmentId: string;
  // Work ID
  workId: string;
  // Callback to update date ranges
  setSelectedDateRange: (dateRange: DateRange) => void;
  // Selected date range
  selectedDateRange: DateRange;
  // Members of the group
  members: UserFragment[];
}

export function PasteRatioChart(props: Props) {
  const { data, isLoading } = useWordCountActivity(
    props.assessmentId,
    props.workId,
    props.members.map((m) => m.id),
    props.selectedDateRange
  );

  if (isLoading) {
    <ChartLoading />;
  }

  return (
    <UserPasteRatioChart
      data={data?.student_paste_ratios}
      users={props.members}
    />
  );
}
